import React from 'react';
import './index.scss';
import TextInfo from '@bit/gerenciatd.unifiedcomponents.text-info';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import Button from '@bit/gerenciatd.unifiedcomponents.button';

export const COMPONENT_NAME = 'Servicing';

const ServicingSection = (servicingInfo) => {
  const {
    'Button-list': buttonList,
    'TextInfo-title': title,
    'TextInfo-subtitle': subtitle,
    'TextInfo-label': iconLabel,
  } = servicingInfo;

  const taggingInfo = {
    ...servicingInfo.taggingInfo,
    componentProduct: '',
    componentVariation: 'all',
    componentName: COMPONENT_NAME,
  }

  const URL_TELEFÓNICA = {
    srcImage: 'https://www.movistar.es/estaticos/empresas/nuevo-empresas/android_app_ico_store.png',
    altImage: 'página explicativa de la app',
    link: 'https://www.movistar.es/empresas/para-tu-oficina/servicios-digitales/app-mi-movistar-empresas',
  }

  const URL_IMAGES_APPS = [
    {
      srcImage: 'https://www.movistar.es/estaticos/Landing_App_Telefonica_Empr/img/gplay.png',
      altImage: 'descarga aplicación Telefonica Empresas en googleplay',
      urlDownload:
        'https://play.google.com/store/apps/details?id=com.movistar.android.mimovistaremp.es',
      market: 'googleplay',
    },
    {
      srcImage: 'https://www.movistar.es/estaticos/Landing_App_Telefonica_Empr/img/app_store.png',
      altImage: 'descarga aplicación Telefonica Empresas en appstore',
      urlDownload: 'https://apps.apple.com/es/app/id1316933492',
      market: 'appstore',
    },
  ];

  return (
    <section className="Servicing-section">
      <TextInfo {...title} />
      <ul className="Servicing-section__list">
        {buttonList && buttonList.list.map(button => (
          <Button
            taggingInfo={{
              ...taggingInfo,
              componentContent: button.label,
            }}
            {...button}
            {...buttonList.props}
          />
        ))}
      </ul>
      <div className="Servicing-section__subtitle-wrapper">
        <TextInfo {...subtitle} />
      </div>
      <div className="Servicing-section_container">
        <span>
          <img className="Servicing-section_container_logo-empresas" src={URL_TELEFÓNICA.srcImage} alt={URL_TELEFÓNICA.altImage} />
        </span>
        <TextInfo {...iconLabel} />
        <CustomLink
          taggingInfo={{
            ...taggingInfo,
            componentContent: 'logo-telefónica',
          }}
          link={URL_TELEFÓNICA.link}
          isBlockElement
        />
      </div>

      <div className="Servicing-section_wrapper-markets">
        {URL_IMAGES_APPS.map((eachApp) => {
          return (
            <CustomLink
              link={eachApp.urlDownload}
              target="_blank"
              taggingInfo={{
                ...taggingInfo,
                componentContent: `button-download-app-${eachApp.market}`,
              }}
              className="Servicing-section_img-wrapper"
            >
              <span>
                <img className="Servicing-section_markets" src={eachApp.srcImage} alt={eachApp.altImage} />
              </span>
            </CustomLink>
          );
        })}
      </div>
    </section>
  );
};

export default ServicingSection;
